export default __webpack_public_path__ + "static/media/mithril.a78ff5c9.svg";